import { Link, useParams, Navigate } from 'react-router-dom';
import { categories, featuredArticles } from '@/mocks/lolita';
import { articleContents } from '@/mocks/articles';
import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const allArticleSlugs = [
  ...categories.flatMap((c) => c.articles.map((a) => a.slug)),
  ...featuredArticles.map((a) => a.slug),
];

const articleHeaderImages: Record<string, string> = {
  'luolita-lishi-qiyuan': 'https://readdy.ai/api/search-image?query=Lolita%20fashion%20history%2C%20victorian%20era%20to%20harajuku%20street%2C%20evolution%20timeline%2C%20cream%20background%2C%20editorial%20photography%2C%20warm%20vintage%20lighting&width=1200&height=500&seq=header-luolita-lishi&orientation=landscape',
  'san-dafengge-quan-jiexi': 'https://readdy.ai/api/search-image?query=Three%20Lolita%20styles%20comparison%2C%20sweet%20gothic%20classic%20side%20by%20side%2C%20pink%20black%20burgundy%2C%20cream%20background%2C%20editorial%20photography%2C%20clean%20display&width=1200&height=500&seq=header-san-dafengge&orientation=landscape',
  'luolita-pinpai-quangonglve': 'https://readdy.ai/api/search-image?query=Lolita%20brands%20collection%2C%20Japanese%20Chinese%20western%20brands%2C%20dress%20display%2C%20cream%20background%2C%20editorial%20photography%2C%20clean%20lighting&width=1200&height=500&seq=header-pinpai-quangonglve&orientation=landscape',
  'luolita-huazhuang-wanquan': 'https://readdy.ai/api/search-image?query=Lolita%20makeup%20guide%2C%20sweet%20gothic%20classic%20makeup%20looks%2C%20cosmetic%20display%2C%20cream%20background%2C%20editorial%20beauty%20photography&width=1200&height=500&seq=header-huazhuang-wanquan&orientation=landscape',
  'luolita-chahui-zhinan': 'https://readdy.ai/api/search-image?query=Lolita%20tea%20party%20guide%2C%20elegant%20table%20setting%2C%20girls%20in%20dresses%2C%20tea%20cups%2C%20cream%20background%2C%20editorial%20photography%2C%20warm%20soft%20lighting&width=1200&height=500&seq=header-chahui-zhinan&orientation=landscape',
  'siji-luolita-bibei': 'https://readdy.ai/api/search-image?query=Lolita%20wardrobe%20essentials%20four%20seasons%2C%20spring%20summer%20autumn%20winter%20outfits%2C%20cream%20background%2C%20editorial%20photography%2C%20clean%20display&width=1200&height=500&seq=header-siji-bibei&orientation=landscape',
  'tianmei-xinshou-zhinan': 'https://readdy.ai/api/search-image?query=Sweet%20Lolita%20beginner%20guide%2C%20cute%20pink%20dress%20with%20strawberry%20print%2C%20lace%20socks%2C%20mary%20jane%20shoes%2C%20clean%20cream%20background%2C%20soft%20dreamy%20lighting%2C%20editorial%20fashion%20photography&width=1200&height=500&seq=header-tianmei-xinshou&orientation=landscape',
  'tianmei-chadress-tuijian': 'https://readdy.ai/api/search-image?query=Sweet%20Lolita%20tea%20party%20dress%20collection%2C%20pastel%20pink%20and%20lavender%20dresses%20with%20lace%2C%20elegant%20display%2C%20cream%20background%2C%20editorial%20fashion%20photography%2C%20soft%20natural%20lighting&width=1200&height=500&seq=header-tianmei-chadress&orientation=landscape',
  'tianmei-fashi-dapei': 'https://readdy.ai/api/search-image?query=Sweet%20Lolita%20hairstyle%20accessories%2C%20twin%20tails%20with%20ribbon%20bows%2C%20pearl%20headband%2C%20cute%20feminine%20style%2C%20cream%20background%2C%20soft%20lighting%2C%20editorial%20beauty%20photography&width=1200&height=500&seq=header-tianmei-fashi&orientation=landscape',
  'tianmei-siji-dapei': 'https://readdy.ai/api/search-image?query=Sweet%20Lolita%20four%20seasons%20outfit%20inspiration%2C%20spring%20floral%20dress%2C%20summer%20light%20fabric%2C%20autumn%20cardigan%2C%20winter%20cape%2C%20cream%20background%2C%20editorial%20fashion%20photography&width=1200&height=500&seq=header-tianmei-siji&orientation=landscape',
  'gete-fengge-jiexi': 'https://readdy.ai/api/search-image?query=Gothic%20Lolita%20style%20analysis%2C%20black%20velvet%20dress%2C%20dark%20rose%20details%2C%20elegant%20gothic%20fashion%2C%20cream%20background%2C%20editorial%20photography%2C%20dramatic%20lighting&width=1200&height=500&seq=header-gete-fengge&orientation=landscape',
  'gete-pinpai-tuijian': 'https://readdy.ai/api/search-image?query=Gothic%20Lolita%20brand%20collection%2C%20black%20dresses%20display%2C%20dark%20elegant%20fashion%2C%20cream%20background%2C%20editorial%20photography%2C%20soft%20dramatic%20lighting&width=1200&height=500&seq=header-gete-pinpai&orientation=landscape',
  'gete-huazhuang-jiaocheng': 'https://readdy.ai/api/search-image?query=Gothic%20Lolita%20makeup%20tutorial%2C%20pale%20skin%2C%20dark%20eyeliner%2C%20dark%20lipstick%2C%20elegant%20gothic%20beauty%2C%20cream%20background%2C%20editorial%20beauty%20photography&width=1200&height=500&seq=header-gete-huazhuang&orientation=landscape',
  'gete-richang-dapei': 'https://readdy.ai/api/search-image?query=Casual%20Gothic%20Lolita%20outfit%2C%20black%20blouse%20skirt%20combination%2C%20subtle%20dark%20aesthetic%2C%20cream%20background%2C%20editorial%20fashion%20photography%2C%20natural%20lighting&width=1200&height=500&seq=header-gete-richang&orientation=landscape',
  'gudian-rumen-zhinan': 'https://readdy.ai/api/search-image?query=Classic%20Lolita%20beginner%20guide%2C%20elegant%20burgundy%20dress%2C%20pearl%20accessories%2C%20victorian%20style%2C%20cream%20background%2C%20editorial%20fashion%20photography&width=1200&height=500&seq=header-gudian-rumen&orientation=landscape',
  'gudian-pinpai-pandian': 'https://readdy.ai/api/search-image?query=Classic%20Lolita%20brands%20collection%2C%20elegant%20dresses%2C%20vintage%20inspired%2C%20cream%20background%2C%20editorial%20photography%2C%20warm%20lighting&width=1200&height=500&seq=header-gudian-pinpai&orientation=landscape',
  'gudian-richang-dapei': 'https://readdy.ai/api/search-image?query=Classic%20Lolita%20office%20wear%2C%20elegant%20blouse%20and%20skirt%2C%20pearl%20earrings%2C%20mature%20feminine%20style%2C%20cream%20background%2C%20editorial%20photography&width=1200&height=500&seq=header-gudian-richang&orientation=landscape',
  'gudian-shoushi-dapei': 'https://readdy.ai/api/search-image?query=Classic%20Lolita%20jewelry%20accessories%2C%20pearl%20necklace%2C%20vintage%20brooch%2C%20elegant%20display%2C%20cream%20background%2C%20editorial%20photography%2C%20soft%20lighting&width=1200&height=500&seq=header-gudian-shoushi&orientation=landscape',
  'luolita-jichu-dapei': 'https://readdy.ai/api/search-image?query=Lolita%20layering%20technique%2C%20blouse%20under%20jumper%20skirt%2C%20cardigan%20over%20dress%2C%20cream%20background%2C%20editorial%20fashion%20photography&width=1200&height=500&seq=header-jichu-dapei&orientation=landscape',
  'secai-dapei-xue': 'https://readdy.ai/api/search-image?query=Lolita%20color%20coordination%2C%20color%20palette%20display%2C%20pink%20white%20mint%20combinations%2C%20cream%20background%2C%20editorial%20photography&width=1200&height=500&seq=header-secai-dapei&orientation=landscape',
  'peishi-jingxuan': 'https://readdy.ai/api/search-image?query=Lolita%20accessories%20guide%2C%20headpiece%20petticoat%20lace%20socks%2C%20mary%20jane%20shoes%2C%20cream%20background%2C%20editorial%20photography%2C%20clean%20display&width=1200&height=500&seq=header-peishi-jingxuan&orientation=landscape',
  'changhe-dapei-zhinan': 'https://readdy.ai/api/search-image?query=Lolita%20outfits%20for%20different%20occasions%2C%20tea%20party%20convention%20daily%20wear%2C%20cream%20background%2C%20editorial%20fashion%20photography&width=1200&height=500&seq=header-changhe-dapei&orientation=landscape',
  'rukeng-quanliu-gonglve': 'https://readdy.ai/api/search-image?query=Lolita%20beginner%20full%20guide%2C%20first%20dress%20unboxing%2C%20happy%20girl%2C%20cream%20background%2C%20editorial%20photography%2C%20warm%20lighting&width=1200&height=500&seq=header-rukeng-quanliu&orientation=landscape',
  'luolita-shuyu-jiedu': 'https://readdy.ai/api/search-image?query=Lolita%20terminology%20guide%2C%20jumper%20skirt%20one%20piece%20comparison%2C%20dress%20types%20display%2C%20cream%20background%2C%20editorial%20photography&width=1200&height=500&seq=header-shuyu-jiedu&orientation=landscape',
  'diyitiao-qunzi': 'https://readdy.ai/api/search-image?query=Choosing%20first%20Lolita%20dress%2C%20girl%20trying%20on%20cute%20dress%2C%20mirror%20reflection%2C%20cream%20background%2C%20editorial%20photography%2C%20soft%20natural%20lighting&width=1200&height=500&seq=header-diyitiao-qunzi&orientation=landscape',
  'yusuan-guihua': 'https://readdy.ai/api/search-image?query=Lolita%20budget%20planning%2C%20affordable%20dress%20options%2C%20price%20comparison%2C%20cream%20background%2C%20editorial%20photography%2C%20clean%20lighting&width=1200&height=500&seq=header-yusuan-guihua&orientation=landscape',
};

function findArticleData(slug: string) {
  const fromDetailed = articleContents[slug];
  if (fromDetailed) return fromDetailed;

  for (const cat of categories) {
    const found = cat.articles.find((a) => a.slug === slug);
    if (found) {
      return {
        title: found.title,
        category: cat.name,
        categorySlug: cat.slug,
        readTime: '10分钟',
        publishedDate: '2025-08-01',
        author: '洛丽塔风格指南',
        tags: [cat.name, '洛丽塔'],
        excerpt: found.excerpt,
        imageQuery: found.imageQuery,
        content: `<p>${found.excerpt}</p><p>本文正在精心撰写中，敬请期待完整版本。在此期间，欢迎浏览我们的其他精选内容。</p>`,
      };
    }
  }

  const fromFeatured = featuredArticles.find((a) => a.slug === slug);
  if (fromFeatured) {
    return {
      title: fromFeatured.title,
      category: fromFeatured.category,
      categorySlug: fromFeatured.categorySlug,
      readTime: fromFeatured.readTime,
      publishedDate: '2025-07-20',
      author: '洛丽塔风格指南',
      tags: [fromFeatured.category, '洛丽塔'],
      excerpt: fromFeatured.excerpt,
      imageQuery: fromFeatured.imageQuery,
      content: `<p>${fromFeatured.excerpt}</p><p>本文正在精心撰写中，敬请期待完整版本。在此期间，欢迎浏览我们的其他精选内容。</p>`,
    };
  }

  return null;
}

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();

  if (!slug) return <Navigate to="/" replace />;

  const article = findArticleData(slug);

  if (!article) {
    if (!allArticleSlugs.includes(slug)) {
      return <Navigate to="/not-found" replace />;
    }
    return (
      <>
        <Navbar />
        <main className="pt-16 section-padding">
          <div className="container-custom text-center py-20">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <i className="ri-file-text-line text-3xl text-foreground-300"></i>
            </div>
            <h1 className="text-xl font-heading font-bold text-foreground-800 mb-3">文章准备中</h1>
            <p className="text-foreground-500 text-sm mb-6">这篇文章正在精心撰写中，敬请期待。</p>
            <Link to="/" className="text-primary-500 hover:text-primary-600 font-medium text-sm">
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const articleUrl = `https://eachbill.cn/article/${slug}`;

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://eachbill.cn/' },
      { '@type': 'ListItem', position: 2, name: article.category, item: `https://eachbill.cn/category/${article.categorySlug}` },
      { '@type': 'ListItem', position: 3, name: article.title, item: articleUrl },
    ],
  };

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    url: articleUrl,
    datePublished: article.publishedDate,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    publisher: {
      '@type': 'Organization',
      name: '洛丽塔风格指南',
      url: 'https://eachbill.cn/',
    },
    isPartOf: {
      '@type': 'WebSite',
      name: '洛丽塔风格指南',
      url: 'https://eachbill.cn/',
    },
    breadcrumb: breadcrumbSchema,
    keywords: article.tags?.join(', '),
  };

  const relatedArticles = categories
    .find((c) => c.slug === article.categorySlug)
    ?.articles.filter((a) => a.slug !== slug)
    .slice(0, 3) || [];

  const headerImg = articleHeaderImages[slug];

  return (
    <>
      <SEOHead
        title={`${article.title} - 洛丽塔风格指南`}
        description={article.excerpt}
        keywords={article.tags?.join(',')}
        canonicalUrl={articleUrl}
        ogType="article"
        articleData={{
          publishedTime: article.publishedDate,
          author: article.author,
          tags: article.tags,
        }}
        schemaData={articleSchema}
      />

      <Navbar />

      <main className="pt-16">
        {/* Article Header */}
        <section className="relative h-[320px] md:h-[420px] flex items-end overflow-hidden">
          {headerImg && (
            <img
              src={headerImg}
              alt={article.title}
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/20"></div>
          <div className="relative z-10 container-custom pb-10 md:pb-14">
            <nav className="flex items-center gap-2 text-white/70 text-xs mb-4 flex-wrap">
              <Link to="/" className="hover:text-white transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <Link to={`/category/${article.categorySlug}`} className="hover:text-white transition-colors">
                {article.category}
              </Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-white">{article.title}</span>
            </nav>
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-white mb-3 leading-tight max-w-3xl">
              {article.title}
            </h1>
            <div className="flex items-center gap-4 text-white/70 text-xs flex-wrap">
              <span className="flex items-center gap-1">
                <i className="ri-user-line"></i> {article.author}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line"></i> {article.publishedDate}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-time-line"></i> {article.readTime}
              </span>
              <span className="bg-white/15 backdrop-blur-sm px-3 py-1 rounded-full text-white/90">
                {article.category}
              </span>
            </div>
          </div>
        </section>

        {/* Article Content */}
        <section className="section-padding bg-background-50">
          <div className="container-custom">
            <div className="max-w-3xl mx-auto">
              <div
                className="prose prose-sm md:prose-base max-w-none
                  prose-headings:font-heading prose-headings:text-foreground-800 prose-headings:font-bold
                  prose-h2:text-xl md:prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-4
                  prose-p:text-foreground-600 prose-p:leading-relaxed prose-p:mb-5 prose-p:text-sm md:prose-p:text-base
                  prose-strong:text-foreground-800 prose-strong:font-semibold
                  prose-a:text-primary-500 hover:prose-a:text-primary-600"
                dangerouslySetInnerHTML={{ __html: article.content }}
              />

              {article.tags && article.tags.length > 0 && (
                <div className="mt-12 pt-8 border-t border-background-200/70">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-xs text-foreground-400">标签：</span>
                    {article.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-3 py-1.5 bg-secondary-50 text-secondary-700 text-xs rounded-full"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {relatedArticles.length > 0 && (
                <div className="mt-12 pt-8 border-t border-background-200/70">
                  <h3 className="font-heading text-lg font-semibold text-foreground-800 mb-5">
                    相关文章推荐
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    {relatedArticles.map((ra) => (
                      <Link
                        key={ra.slug}
                        to={`/article/${ra.slug}`}
                        className="group bg-background-100 rounded-lg p-4 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                      >
                        <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                          {ra.title}
                        </h4>
                        <p className="text-xs text-foreground-500 line-clamp-2">{ra.excerpt}</p>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}